import { takeLatest, call, fork, put } from "redux-saga/effects";
import { get as _get } from "lodash";

import { removeUploadedFile, saveMappingData } from "../services/fileUpload";

import {
  REMOVE_UPLOADED_FILE_REQUEST, REMOVE_UPLOADED_FILE_SUCCESS, REMOVE_UPLOADED_FILE_ERROR,
  SAVE_UPLOAD_MAPPING_DATA_REQUEST, SAVE_UPLOAD_MAPPING_DATA_SUCCESS, SAVE_UPLOAD_MAPPING_DATA_ERROR,
} from "../actions/fileUpload";

import { UPDATE_APP_LOADING } from "../actions/application";

function* workerSaveUploadMappingData({ payload }) {

  try {
    yield put({ type: UPDATE_APP_LOADING, loading: true });

    const response = yield call(saveMappingData, payload);

    if ((response.flag || false) === true) {
      yield put({
        type: SAVE_UPLOAD_MAPPING_DATA_SUCCESS,
        payload: {
          data: _get(response, "data", {}),
          message: (response.message || ""),
          payload: payload
        }
      });
    } else {
      yield put({
        type: SAVE_UPLOAD_MAPPING_DATA_ERROR,
        error: {
          message: _get(response, "message", "Something went wrong while storing uploaded data."),
          errors: _get(response, "error", {})
        }
      });
    }

  } catch (error) {

    yield put({
      type: SAVE_UPLOAD_MAPPING_DATA_ERROR,
      payload: {
        message: _get(error, "message", "Something went wrong while storing uploaded data.")
      }
    });
  } finally {

    yield put({ type: UPDATE_APP_LOADING, loading: false });
  }
}

function* workerRemoveUploadedFile({ payload = {} }) {

  try {
    yield put({ type: UPDATE_APP_LOADING, loading: true });

    const response = yield call(removeUploadedFile, payload);

    if ((response.flag || false) === true) {
      yield put({
        type: REMOVE_UPLOADED_FILE_SUCCESS,
        payload: {
          data: _get(response, "data", {}),
          message: (response.message || ""),
          uploadType: (payload.uploadType || "")
        }
      });
    } else {
      yield put({
        type: REMOVE_UPLOADED_FILE_ERROR,
        error: {
          message: _get(response, "message", "Something went wrong while removing uploaded file."),
          errors: (response.error || {})
        }
      });
    }

  } catch (error) {
    yield put({
      type: REMOVE_UPLOADED_FILE_ERROR,
      error: {
        message: _get(error, "message", "Something went wrong while removing uploaded file.")
      }
    });
  } finally {
    yield put({ type: UPDATE_APP_LOADING, loading: false });
  }
}

function* watcherSaveUploadMappingData() {
  yield takeLatest(SAVE_UPLOAD_MAPPING_DATA_REQUEST, workerSaveUploadMappingData);
}

function* watcherRemoveUploadedFile() {
  yield takeLatest(REMOVE_UPLOADED_FILE_REQUEST, workerRemoveUploadedFile);
}

const fileUploadSaga = [
  fork(watcherRemoveUploadedFile),
  fork(watcherSaveUploadMappingData),
]

export default fileUploadSaga;
